import{ updatetheme,themedata }  from '../../../../store/theme_data';
import { useSelector } from "react-redux";
import React,{ useEffect,useState } from 'react';
import {Box,Typography,Menu, MenuItem,Button} from '@mui/material';
import Divider from '@mui/material/Divider';
// import {livedata} from '../../../../Restclient/datacollection'



export default function ValueCardStatus(props){
    const theme = useSelector((state) => state.themedata.theme)
    const livedata = useSelector((state) => state.mainpagedata.livedata);

    const [optionsmin, setOptionsMin] = React.useState(0);
    const [optionsmax, setOptionsMax] = useState(0);
    // const [value, setValue] = React.useState('NA')
    const [value, setValue] = React.useState(0)
    const [time, setTime] = React.useState("01-01-1970 00:00:00")
    const Tags=props.widgetprop.props.extended.tagprops


      useEffect(() => {
        if(livedata.length) {
          let dataupdated=false;
            for(let i=0; i<livedata.length; i++) {
                if(parseInt(props.widgetprop.props.extended.tagprops[0].tagid) === parseInt(livedata[i].TagId)) {
                    dataupdated=true
                    if(props.widgetprop.props.extended.tagprops[0].value_substitute!=undefined ){
                      if(props.widgetprop.props.extended.tagprops[0].value_substitute.values_list.length!=0){
                         props.widgetprop.props.extended.tagprops[0].value_substitute.values_list.map((val,index)=>{
                          if(val[0]==livedata[i].value){
                            setValue(val[1])
                          }
                        })
                      }
                      else{
                        setValue(livedata[i].value.toFixed(2))
                      }
                    }
                    else{
                      setValue(livedata[i].value.toFixed(2))
                    }
                    var date = new Date(livedata[i].timestamp * 1000)
                    var month = date.getMonth()+1;
                    var timestamp = (date.getDate() > 9 ? date.getDate() : "0"+date.getDate()) + "-" + (month > 9 ? month : "0"+ month) + "-" + date.getFullYear() + " " + (date.getHours() > 9 ? date.getHours() : "0"+date.getHours()) + ":" + (date.getMinutes() > 9 ? date.getMinutes() : "0"+date.getMinutes()) + ":" + (date.getSeconds() > 9 ? date.getSeconds() : "0"+date.getSeconds())
                    setTime(timestamp)
                }
                else{
                  // if(i==livedata.length-1 && dataupdated===false){
                  //   setValue("NA");
                  //   setTime("");
                  // }
                }
            }
        }
    },[livedata])



    return(
        <div style={{height: 'calc(100% - 55px)', width: 'calc(100% - 15px)', padding: '10px', overflow: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <div style={{display: 'flex', height: '88%', width: '95%', alignItems: 'center', justifyContent: 'center'}}>
            <div style={{display: 'flex', flexDirection: 'column', padding: '10px',alignItems: 'center', justifyContent: 'center', width: '100%'}}>
                <Typography style={{fontFamily:"Roboto", fontSize:"58px",fontWeight:500, color: 'var(--PrimaryText)', width: '90%', whiteSpace: 'nowrap',overflow: 'hidden', textOverflow: 'ellipsis'}}> {value} </Typography>
            </div>
        </div>
        <div style={{display: 'flex', alignItems:'center', justifyContent: 'center'}}>
            <Typography style={{fontFamily:"Roboto", fontSize:"18px",fontWeight:400, color: 'var(--PrimaryText)'}}> {time} </Typography>
        </div>
        {/*<div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"60px",alignItems:'baseline',paddingLeft:"20px"}}>
            <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Minimum</div>
            <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmin}</div>
        </div>
        <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemin}</div>

        <div style={{position:"inline-flex",display:"flex", flexDirection:"row", paddingTop:"40px",alignItems:'baseline',paddingLeft:"20px",paddingTop:"50px"}}>
            <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"14px",fontWeight:400}}>Maximum</div>
            <div style={{color:theme=='light'?"#3C3C3C":"#FFFFFF", fontFamily:"Roboto", fontSize:"24px",fontWeight:400,paddingLeft:"206px"}}>{optionsmax}</div>
        </div>
        <div style={{color:theme=='light'?"#3C3C3C":"#C1C1C1", fontFamily:"Roboto", fontSize:"12px",fontWeight:400,paddingLeft:"235px"}}>{optionstimemax}</div>*/}
    </div>
    )
}